import * as React from "react";
import PaymentRecommendation from "../../../model/payment/PaymentRecommendation";
import Payment from "../../../model/payment/Payment";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import {InvoiceActivityPaymentItem} from "../activityStream/items/InvoiceActivityPaymentItem";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./paymentConfirmation.scss";

interface IProps {
	recommendation: PaymentRecommendation,
	confirmPayment: () => void,
	isLoading: boolean,
	rejectPayment: () => void
}

export const PaymentConfirmation: React.SFC<IProps> = (props) => {
	const recommendationAsPayment = Payment.createFromRecommendation(props.recommendation);
	return (
		<div key={props.recommendation.id} className="c-payment-confirmation">
			<div className="c-payment-confirmation_inside-container">
				<div className="c-common-details_activity-stream-item-container">
					<InvoiceActivityPaymentItem icon={Icon.Alert}
												iconColor={IconColor.White}
												iconVariant={"orange"}
												activity={recommendationAsPayment}/>
				</div>
				<div className="c-payment-confirmation_buttons-container">
					<ButtonTertiary label={"Reject"}
									onClick={props.rejectPayment}/>
					<ButtonPrimary label={"Confirm payment"}
								   disabled={props.isLoading}
								   isLoading={props.isLoading}
								   onClick={props.confirmPayment}/>
				</div>
			</div>
		</div>
	)
};
